import {
  IsUUID,
  IsString,
  IsEnum,
  IsOptional,
  IsEmail,
} from 'class-validator';
import { ClientStatus } from '../../interface/clients/clients-response.interface';
import { CreateClientInterface, UpdateClientInterface } from '../../interface/clients/modify-clients.interface';

export class CreateClientsDto implements CreateClientInterface {

  @IsOptional()
  @IsString()
  contact_person!: string | null;

  @IsOptional()
  @IsString()
  designation!: string | null;

  @IsOptional()
  @IsString()
  contact_number!: string | null;

  @IsOptional()
  @IsEmail()
  email!: string | null;

  @IsEnum(ClientStatus)
  status!: ClientStatus;

  @IsOptional()
  @IsUUID()
  created_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  company_id!: string | null;
}

export class UpdateClientsDto implements UpdateClientInterface {

  @IsUUID()
  id!: string;

  @IsOptional()
  @IsString()
  contact_person?: string | null;

  @IsOptional()
  @IsString()
  designation?: string | null;

  @IsOptional()
  @IsString()
  contact_number?: string | null;

  @IsOptional()
  @IsEmail()
  email?: string | null;

  @IsOptional()
  @IsEnum(ClientStatus)
  status?: ClientStatus;

  @IsUUID()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  company_id?: string | null;
}